import Globalize from '@sprinx/globalize';
import forLocale from '../utils/forLocale';
var localeParser = {};
/**
 * @param {string} strNum
 * @returns {number}
 */

var numberParser = function numberParser(strNum) {
  return forLocale(localeParser, function (parser) {
    if (typeof strNum !== 'string') {
      return undefined;
    }
    /* istanbul ignore next */


    if (!parser) parser = Globalize.numberParser();
    return parser(strNum);
  });
};

export default numberParser;